import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { keyframes } from "@mui/system";
import useFocusTrapIn from "../hooks/focusTrapIn";

const typing = keyframes`
  from { width: 100% }
  to { width: 0% }
`;

const blink = keyframes`
  from, to { border-color: transparent }
  50% { border-color: #ffffff; }
`;

const TitleText = () => {
  const isMobile = useMediaQuery("(max-width:580px)");
  const hasEnoughVerticalSpace = useMediaQuery("(min-height: 750px)");
  const isIn = useFocusTrapIn();
  const [animationHappened, setAnimationHappened] = React.useState(() =>
    isIn ? true : false
  );

  React.useEffect(() => {
    if (isIn) {
      setAnimationHappened(true);
    }
  }, [isIn]);

  React.useEffect(() => {
    const timeout = setTimeout(() => setAnimationHappened(true), 3000);
    return () => clearTimeout(timeout);
  }, []);

  if (!hasEnoughVerticalSpace) return <></>;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 75,
        left: "50%",
        right: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        justifyContent: "flex-end",
        width: "fit-content",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          letterSpacing: "0.2rem",
          fontSize: isMobile ? "2.1rem" : "4rem",
        }}
      >
        We Are ExEgypt
      </Typography>
      <Box
        sx={{
          position: "fixed",
          height: "100%",
          backgroundColor: "#cd1027",
          borderLeft: "0.3rem solid white",
          animation: `${typing} ${
            animationHappened ? "0s" : "1.8s"
          } steps(30, end), ${blink} 0.75s step-end ${isIn ? "" : "infinite"}`,
          animationDelay: "0s, 2.2s",
        }}
      />
    </Box>
  );
};

export default TitleText;
